export default __webpack_public_path__ + "static/media/burger.39a265c2.svg";